import { Action, Reducer } from 'redux';
import {
  QuoteCountStatusState,
  QuoteCountStatusTypes,
  QuoteCountStatusActionTypes
} from './quoteCountStatusTypes';

export const INITIAL_STATE: QuoteCountStatusState = {
  quoteCountStatus: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const quoteCountStatusReducer: Reducer<QuoteCountStatusState> = (
  state: QuoteCountStatusState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as QuoteCountStatusActionTypes;
  switch (actionTypes.type) {
    case QuoteCountStatusTypes.GET_QUOTE_COUNT_STATUS:
      return {
        ...state,
        quoteCountStatus: { ...state.quoteCountStatus, isLoading: true }
      };
    case QuoteCountStatusTypes.SAVE_QUOTE_COUNT_STATUS:
      return {
        ...state,
        quoteCountStatus: {
          ...state.quoteCountStatus,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case QuoteCountStatusTypes.RESET_REDUCER_QUOTE_COUNT_STATUS:
      return {
        ...state,
        quoteCountStatus: INITIAL_STATE.quoteCountStatus
      };
    default:
      return state;
  }
};

export default quoteCountStatusReducer;

